// import { isAllowedWithoutCurrency, toLogin } from "./utils";

import req from "./https.js";

export const request = (
  method,
  path,
  data = null,
  needAuth = false,
  needCompanyId = false
) =>
  req(
    method,
    `${process.env.REACT_APP_MAIN_API}${path}`,
    data,
    needAuth,
    needCompanyId
  );

export const requestImage = (
  method,
  path,
  data = null,
  needAuth = false,
  needCompanyId = false
) =>
  req(
    method,
    `${process.env.REACT_APP_IMAGE_SERVER}${path}`,
    data,
    needAuth,
    needCompanyId
  );

// export const requestUtil = (method, path, data = null, needAuth = false) =>
//   req(method, `${process.env.REACT_APP_API_UTIL_URL}${path}`, data, needAuth);
